import React from 'react';
import '../../styles/modes/customMode.css';

const PathSequence = ({ customPath, startId, endId, removePointFromPath }) => {
  return (
    <>
      <h5 className="path-sequence-title">Selected Path Sequence</h5>
      {customPath.length > 0 ? (
        <div className="path-sequence-list">
          {customPath.map((point, index) => (
            <div key={`path-${point.id}-${index}`} className="path-sequence-item">
              <span className="path-point-name">
                {point.name}. {point.latitude.toFixed(4)}, {point.longitude.toFixed(4)}
                {point.id === startId && <span className="start-badge">Start</span>}
                {point.id === endId && <span className="end-badge">End</span>}
              </span>
              {!(index === 0 && point.id === startId) && (
                <button 
                  className="path-point-remove" 
                  onClick={() => removePointFromPath(index)}
                  title="Remove from path"
                >
                  ✕
                </button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="empty-path-message">
          {startId ? "Please select the first location point after the start point" : "Please set a start point first"}
        </p>
      )}
    </>
  );
};

export default PathSequence;
